// Small PWA display-mode / platform detection helpers used by the install prompt.

// True when the app is already running as an installed PWA (standalone window),
// in which case no install affordance should be shown. Covers the standard
// display-mode media query and the legacy iOS `navigator.standalone` flag.
function isStandalone () {
  if (typeof window === 'undefined') { return false }
  const mql = window.matchMedia && window.matchMedia('(display-mode: standalone)')
  if (mql && mql.matches) { return true }
  return window.navigator && window.navigator.standalone === true
}

// True on iOS/iPadOS Safari, where `beforeinstallprompt` never fires and the
// only way to install is the manual "Add to Home Screen" Share-sheet flow.
function isIos () {
  if (typeof window === 'undefined') { return false }
  const ua = window.navigator.userAgent || ''
  const iOsDevice = /iPad|iPhone|iPod/.test(ua)
  // iPadOS 13+ reports as Mac; detect the touch-capable "Mac" as iPad.
  const iPadOs = /Macintosh/.test(ua) && typeof document !== 'undefined' &&
    'ontouchend' in document
  return iOsDevice || iPadOs
}

export {
  isStandalone,
  isIos
}
